import React, { useEffect, useState } from "react";

import { Box, Typography, Button } from "@mui/material";
import YourGuide from "../../assets/media/your-guide.jpg";
import { useNavigate } from "react-router-dom";
import { getCategories } from "../../api/admin/service-management";

export default function SeventhSectionHome({ categories }: { categories: any[] }) {
  const [serviceIds, setServiceIds] = useState([]);
  const navigate = useNavigate();

  const buildServicesState = (ids = []) => {
    return ids.reduce((acc, id) => {
      if (id && Number(id)) {
        acc[Number(id)] = true;
      }
      return acc;
    }, {});
  };

  const handleStartPlanningToday = () => {
    const servicesState = buildServicesState(serviceIds);

    navigate("/home/list-of-funeral-homes/", {
      state: {
        needType: "preneed",
        services: servicesState,
      },
    });
  };


  useEffect(() => {
    if (categories && categories.length > 0) {
      const preNeedCategories = categories.filter((cat: any) =>
        cat.needTypes?.includes("pre_need"),
      );
      const ids = preNeedCategories.map((item: any) => item.id);
      setServiceIds(ids);
    }
  }, [categories]);


  return (
    <Box
      sx={{
        display: { xs: "block", md: "flex" },
        height: { xs: "auto", md: "70vh" },
      }}
    >
      {/* Left Section */}
      <Box
        sx={{
          width: { sm: "90%", md: "50%" },
          mx: { xs: "auto", md: 0 },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 3, md: 10 },
          pt: { xs: 4, md: 8 },
        }}
      >
        <Box
          sx={{
            textAlign: { xs: "center", md: "left" },
            paddingLeft: { xs: 0, md: "2rem" },
            maxWidth: 600,
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { xs: "28px", sm: "36px", md: "59px" },
              lineHeight: "100%",
              color: "#104145",
              mb: 3,
            }}
          >
            Guidance&nbsp;
            <span style={{ color: "#9F7F2C" }}>You Can Rely On</span>
          </Typography>

          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { xs: "14px", sm: "18px", md: "24px" },
              lineHeight: "140%",
              color: "#104145",
              mb: 4,
            }}
          >
            From first questions through the decisions ahead, MemorialGo offers
            guidance, helpful tools, and trusted options.
          </Typography>

          <Button
            variant="contained"
            sx={{
              color: "#104145",
              backgroundColor: "#EBD28D",
              textTransform: "none",
              padding: "0.313rem 1.375rem",
              fontWeight: 400,
              borderRadius: "8px",
              fontSize: { xs: "18px", md: "22px" },
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              display: "block",
              mx: { xs: "auto", md: 0 },
              marginBottom: { md: "4rem" },
            }}
            onClick={handleStartPlanningToday}
          >
            Start Planning Today
          </Button>
        </Box>
      </Box>

      {/* Right Section Image */}
      <Box
        sx={{
          width: { xs: "100%", sm: "90%", md: "60%" },
          mx: { xs: "auto", md: 0 },
          height: { xs: "auto", md: "70vh" },
          overflow: "hidden",
          mt: { xs: 4, md: 0 },
        }}
      >
        <img
          src={YourGuide}
          alt="your-guide-img"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
    </Box>
  );
}
